export const isEdge = () => {
    try {
        return window.navigator.userAgent.indexOf("Edge") > -1
    }catch (e){
        return true;
    }
};

export const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isFirefox = () => {
    return typeof InstallTrigger !== 'undefined';
}

function getOS() {
    try {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }
    } catch (e) {
        os = 'unknown';
    }

    return os;
}

export const isWindows = () => {
    return getOS() === 'Windows';
};


// WEBPACK FOOTER //
// ./src/js/utils/checkBrowser.js